import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ViewApplicationBaseComponent } from "../../../shared/view-application-base/view-application-base.component";
import { ViewApplicationDetailsRcConstants } from "./view-application-details-rc.constant";
import { ApplicationViewService } from "../../../shared/application-view.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { RouterParamsService } from "../../../../shared/services/route-params.service";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
let ViewApplicationDetailsRcComponent = class ViewApplicationDetailsRcComponent extends ViewApplicationBaseComponent {
    applicationViewService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    routerParamsService;
    applicationTypeCtrl = ViewApplicationDetailsRcConstants.TYPE_CTRL;
    applicationTypeLbl = ViewApplicationDetailsRcConstants.TYPE_LBL;
    descriptionCtrl = ViewApplicationDetailsRcConstants.DESCRIPTION_CTRL;
    detailsFormGroupName = ViewApplicationDetailsRcConstants.DETAILS_FORM_GROUP_NAME;
    reasonForApplicationFormControlName = ViewApplicationDetailsRcConstants.REASON_FOR_APPLICATION_CONTROL_NAME;
    typeOfTransferFormControlName = ViewApplicationDetailsRcConstants.TYPE_OF_TRANSFER_CONTROL_NAME;
    propertyTypeFormControlName = ViewApplicationDetailsRcConstants.PROPERTY_TYPE_CONTROL_NAME;
    ratesAccountNumberFormControlName = ViewApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_CONTROL_NAME;
    electronicReferenceFormControlName = ViewApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_CONTROL_NAME;
    attorneyReferenceFormControlName = ViewApplicationDetailsRcConstants.ATTORNEY_REFERENCE_CONTROL_NAME;
    councilReferenceFormControlName = ViewApplicationDetailsRcConstants.COUNCIL_REFERENCE_CONTROL_NAME;
    // Labels and headers
    descriptionLbl = ViewApplicationDetailsRcConstants.DESCRIPTION_LBL;
    reasonForApplicationLabel = ViewApplicationDetailsRcConstants.REASON_FOR_APPLICATION;
    typeOfTransferLabel = ViewApplicationDetailsRcConstants.TYPE_OF_TRANSFER_LABEL;
    propertyTypeLabel = ViewApplicationDetailsRcConstants.PROPERTY_TYPE_LABEL;
    ratesAccountNumberLabel = ViewApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_LABEL;
    electronicReferenceLabel = ViewApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_LABEL;
    attorneyReferenceLabel = ViewApplicationDetailsRcConstants.ATTORNEY_REFERENCE_LABEL;
    councilReferenceLabel = ViewApplicationDetailsRcConstants.COUNCIL_REFERENCE_LABEL;
    applicationTypePlaceHolder = ViewApplicationDetailsRcConstants.APPLICATION_PLACE_HOLDER;
    applicationTypes = [];
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    typeOfTransferLookupOptions = [];
    selectedApplicationRCSubscription;
    getLookupsObservableSubscription;
    constructor(applicationViewService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, routerParamsService) {
        super(applicationViewService, aflaModuleStrategyService, selectedApplicationService, routerParamsService);
        this.applicationViewService = applicationViewService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.routerParamsService = routerParamsService;
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
    }
    handleRouteChange() {
    }
    loadMetadata() {
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationRCSubscription = this.selectedApplicationService.$selectedApplication.subscribe({
            next: (application) => {
                if (application && application.id > 0) {
                    this.selectedApplication = application;
                    this.populateForm(this.selectedApplication);
                    this.disableForm(this.selectedApplication);
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    populateForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.markAsTouched();
        else
            return;
        this.detailsForm.get(this.applicationTypeCtrl).setValue(application.type);
        this.detailsForm.get(this.descriptionCtrl).setValue(application.description);
        this.detailsForm.get(this.reasonForApplicationFormControlName).setValue(application.reasonForApplication);
        this.detailsForm.get(this.typeOfTransferFormControlName).setValue(application.typeOfTransfer);
        this.detailsForm.get(this.propertyTypeFormControlName).setValue(application.propertyType);
        this.detailsForm.get(this.ratesAccountNumberFormControlName).setValue(application.ratesAccountNumber);
        this.detailsForm.get(this.electronicReferenceFormControlName).setValue(application.electronicReference);
        this.detailsForm.get(this.attorneyReferenceFormControlName).setValue(application.attorneyReference);
        this.detailsForm.get(this.councilReferenceFormControlName).setValue(application.councilReference);
    }
    disableForm(application) {
        if (application && application.appId > 0)
            this.detailsForm.get(this.applicationTypeCtrl).disable();
        this.detailsForm.get(this.descriptionCtrl).disable();
        this.detailsForm.get(this.reasonForApplicationFormControlName).disable();
        this.detailsForm.get(this.typeOfTransferFormControlName).disable();
        this.detailsForm.get(this.propertyTypeFormControlName).disable();
        this.detailsForm.get(this.ratesAccountNumberFormControlName).disable();
        this.detailsForm.get(this.electronicReferenceFormControlName).disable();
        this.detailsForm.get(this.attorneyReferenceFormControlName).disable();
        this.detailsForm.get(this.councilReferenceFormControlName).disable();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.appController.selectedModuleID} and deleted eq false`
        };
        this.getLookupsObservableSubscription = this.applicationViewService.getLookupsObservable(params).subscribe({
            next: (response) => this.onGetLookupsCompleted(response),
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const typeOfTransfer = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.toLowerCase() === "applicationtype") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.toLowerCase() === "transfertype") {
                    typeOfTransfer.push(JSON.parse(item.content));
                }
            });
        }
        this.applicationTypes = applicationTypes;
        this.typeOfTransferLookupOptions = typeOfTransfer;
        this.changeDetectorRefs.detectChanges();
        this.subscribeToSelectedApplication();
    }
    static ctorParameters = () => [
        { type: ApplicationViewService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: RouterParamsService }
    ];
};
ViewApplicationDetailsRcComponent = __decorate([
    Component({
        selector: "app-view-application-details-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsRcComponent);
export { ViewApplicationDetailsRcComponent };
